import React, { useState, useEffect, useCallback } from 'react';
import Typography from '@mui/material/Typography';
import { useHistory } from "react-router-dom";
import requests from 'api/requests';
import { IMainLayoutProps } from 'layout/main/types';
import { LockOutlined } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import AuthModel from 'models/AuthModel';


export default function CorpRedirect(props:IMainLayoutProps) {
  const history = useHistory()
  const [loading, setLoading] = useState(true);
  
  const load_companies = useCallback(() => {
    requests.get('/corp/company/', {limit: 1}).then((r) => {
      const companies = r.body;
      if(companies.count){
        const new_url = props.startRoute.start_path.replace("/:company", `/${companies.results[0].id}`);
        history.push(`${new_url}/`);
      }else{
        setLoading(false);
      }
    })
  }, [history, props.startRoute.start_path])

  useEffect(() => load_companies(), [load_companies]);

  if(loading){
    return "";
  }

  return (
    <Box textAlign="center">
      <Typography variant="h1" color="textSecondary">
        <LockOutlined fontSize="large" />
      </Typography>
      <Typography variant="h6" color="textSecondary">
        Не має доступу до керування компаніями
      </Typography>
      <Typography variant="subtitle1" color="textSecondary">
        {AuthModel.info.email}
      </Typography>
      <Button
        onClick={()=>{
          AuthModel.logout();
        }}
      >Вийти</Button>
    </Box>
  );
}
